export default "__VITE_ASSET__CM8dn9lG__"